import { MicrosoftAppType } from '../models/moovStepDefinition';

export class MicrosoftAuthorizedEntitiesRequest{
    public customerId!:number;
    public appType?:MicrosoftAppType; //missing means 'calendar'
}
